export const translations = {
    stepLabel: {
        START: 'Početak',
        SUBMITTER: 'Podnosilac',
        DOCUMENTATION: 'Dokumentacija',
        CONFIRMATION: 'Potvrda',
        INTRO_START: 'Početak',
        INTRO_DOCUMENTATION: 'Dokumentacija',
        INTRO_CONFIRMATION: 'Potvrda',
    },
    validationMessages: {
        REQUIRED_FIELD: 'Obavezno polje',
        REQUIRED_FIELD_POLICY_NO_UCN: 'Potrebno je uneti Broj polise ili JMBG osiguranika',
        PHONE_NUMBER_FORMAT: 'Potrebno je uneti broj telefona u odgovarajućem formatu (+xxxxxxxxxx)',
        PHONE_NUMBER_FORMAT_SERBIAN:
            'Morate da unesete broj telefona mobilnog operatera iz Srbije (u obliku +3816xxxxxx)',
        EMAIL_ADDRESS_FORMAT: 'Potrebno je uneti e-mail adresu u odgovarajućem formatu (xx@xx.xx)',
        NOT_ADULT: 'Lice je maloletno.',
        UCN_INVALID_FORMAT: 'JMBG nije u odgovarajućem formatu!',
        CONTACT_REQUIRED: 'Obavezno je uneti jedan kontakt podatak (email ili mobilni telefon)',
        LEGAL_ENTITY_ROLA_FIELD_INVALID: 'Ne dozvoljeno svojstvo za pravno lice ili preduzetnika',
        LEGAL_ENTITY_NUMBER_INVALID_FORMAT: 'Matični broj nije u ispravnom formatu. Proverite podatke.',
        VAT_INVALID_FORMAT: 'Uneti PIB nije u ispravnom formatu. Proverite podatke.',
        INDIVIDUAL_ROLA_FIELD_INVALID: 'Ne dozvoljeno svojstvo za fizičko lice',
    },
    personalInfo: {
        CLAIM_SUBMITTED_BY: 'Prijavu podnosi',
        NAME: 'Ime',
        LAST_NAME: 'Prezime',
        UCN: 'JMBG',
        ADDRESS: 'Adresa',
        CITY: 'Mesto stanovanja',
        MOBILE: 'Mobilni telefon',
        MOBILE_STAR: 'Mobilni telefon *',
        EMAIL: 'E-mail',
    },
    legalPersonType: {
        INDIVIDUAL: 'Fizičko lice',
        LEGAL: 'Pravno lice',
    },
    legalInfo: {
        PERSON: 'Pravno lice ili preduzetnik',
        CONTACT_INFO: 'Vaši kontakt podaci',
        SUBMITTER_LEGAL_NAME: 'Poslovno ime',
        ID: 'Matični broj',
        VAT: 'PIB',
        EMAIL: 'E-mail',
        NAME: 'Ime',
        LAST_NAME: 'Prezime',
        MOBILE: 'Mobilni telefon *',
        CONTACT_EMAIL: 'E-mail',
    },
    waitingPeriod: {
        TITLE: 'DATUM NASTANKA OSIGURANOG SLUČAJA JE U KARENCI.',
        INFO: 'Karenca je period na početku osiguranja u kom ugovarač ima obavezu da plaća premiju, a osiguravač nema obavezu da plati naknadu iz osiguranja, ako nastupi osigurani slučaj.',
        FOOTER: 'Ukoliko želite da ipak nastavite sa prijavom i dobijete zvaničnu odluku, izaberite NASTAVI.',
        DAYS_TEXT: 'dan/dana karence za konkretnu polisu',
    },
    documentation: {
        ADD_DOC: 'Dodajte dokumenta u odgovarajuće kategorije',
        CHOOSE_DOC: 'odaberi dokument',
        TOTAL_UPLOAD_SIZE_LABEL: 'Ukupna veličina priloga koju možete poslati je ',
        TOTAL_UPLOAD_SIZE_LEFT_LABEL: 'Preostala veličina priloga koju možete poslati je ',
        DOCUMENTATION_MB_SPACE: ' MB.',
        ALLOWED_FILE_FORMATS: 'Dozvoljeni formati su: ',
        LOADING_MESSAGE: 'Podaci se prosleđuju. Molimo sačekajte.',
        COMPRESS_MESSAGE: 'Fajlovi se kompresuju. Molimo sačekajte.',
    },
    confirmationScreen: {
        BASIC_INFORMATION: 'Osnovni podaci',
        POLICY_NUMBER: 'Broj polise',
        OPENED_REQUESTS: 'Po slanju podataka otvorićemo sledeće posebne zahteve:',
        REQUEST: 'Zahtev',
        DESCRIPTION: 'Opis',
        DAMAGE_PLACE_AND_ADDRESS: 'Mesto i adresa štete',
        INJURIES: 'Povrede i/ili nematerijalne posledice nezgode',
        NOTE_PREMIUM:
            'Ako se desi osigurani slučaj, iznos štete koji isplaćujemo ćemo umanjiti za iznos nenaplaćene, a dospele premije osiguranja.',
        NOTE_INTERNATIONAL_SANCTIONS:
            'Osiguravač nije u obavezi da pruži osiguravajuće pokriće niti da plati bilo kakav odštetni zahtev ili isplati bilo kakvu naknadu na osnovu ugovora o osiguranju u onoj meri u kojoj bi ga pružanje takvog pokrića, plaćanje takvog odštetnog zahteva ili omogućavanje takve naknade izložilo bilo kakvoj sankciji, zabrani ili ograničenju na osnovu rezolucija Ujedinjenih nacija ili trgovinskih ili ekonomskih sankcija, zakona ili propisa Evropske unije, Sjedinjenih Američkih država ili Republike Srbije.',
        AGREEMENT:
            'Saglasan/-na sam da Generali Osiguranje Srbija a.d.o. sa mnom kontaktira, šalje mi korisne informacije, ponude i obaveštenja o proizvodima i uslugama osiguranja.',
        PRIVACY: 'Više o načinu na koji upravljamo vašim podacima možete pročitati u našoj ',
        PRIVACY_POLICY_LINK: 'Politici privatnosti',
        PRIVACY_POLICY_URL: 'https://www.generali.rs/footer.1056.html',
        ENSUREE:
            'Osiguravač nije u obavezi da pruži osiguravajuće pokriće niti da plati bilo kakav odštetni zahtev ili isplati bilo kakvu naknadu na osnovu ugovora o osiguranju u onoj meri u kojoj bi ga pružanje takvog pokrića, plaćanje takvog odštetnog zahteva ili omogućavanje takve naknade izložilo bilo kakvoj sankciji, zabrani ili ograničenju na osnovu rezolucija Ujedinjenih nacija ili trgovinskih ili ekonomskih sankcija, zakona ili propisa Evropske unije, Sjedinjenih Američkih država ili Republike Srbije.',
        WRONG_PASS: 'Lozinka je neispravna ili je istekla. Proverite i pokušajte ponovo.',
        CLAIM_ERROR: 'Šteta nije snimljena. Pokušajte ponovo.',
        DATE: 'Datum nastanka',
        POLICY_SUBMITTER: 'Zahtev podnosi',
        POLICY_SUBMITTER_CONTACT: 'Kontakt podaci podnosioca',
        WAITING_PERIOD: 'Period čekanja',
        WAITING_PERIOD_TEXT:
            'Pravo na isplatu naknade iz osiguranja stiče se po protoku perioda čekanja koji iznosi 30 dana od dana nastanka osiguranog slučaja.',
    },
    success: {
        SUCCESS: 'Uspešno ste podneli zahtev. ',
        CLAIM_NUMBER: 'Broj zahteva je ',
        NOTIFICATION_SEND: 'Potvrda o prijavi vam je poslata na e-mail.',
    },
    POLICY: 'Polisa',
    POLICY_NUMBER_OR_UCN: 'Broj polise ili JMBG osiguranika',
    POLICY_UCN: 'JMBG osiguranika',
    RISKS: 'Osigurani rizik',
    CHOOSE_RISK: 'Izaberite osigurani rizik',
    OCCURRENCE_DATE: 'Datum nastanka osiguranog slučaja',
    OCCURRENCE_DATE_TOOLTIP: 'Datum kada je nastao slučaj koji se prijavljuje',
    CHOOSE_SUBMITTER_TYPE: 'Želim da prijavim zahtev kao:*',
    DATE: 'Datum*',
    YES: 'Da',
    NO: 'Ne',
    CITY: 'Mesto',
    STREET: 'Ulica',
    STREET_NUMBER: 'Broj',
    LEGAL_ENTITY_PERSON_ROLE: 'Svojstvo',
    CHOOSE_LEGAL_ENTITY_PERSON_ROLE: 'Izaberite svojstvo',
    FULL_STOP: '.',
    intro: {
        INTRO_MESSAGE_1_TITLE: 'PRE NEGO ŠTO ZAPOČNETE',
        INTRO_MESSAGE_1_LINE_1_1: 'Pripremite potrebna dokumenta',
        INTRO_MESSAGE_1_LINE_1_2: ' (navedena u sledećoj poruci).',
        INTRO_MESSAGE_1_LINE_2: 'Popunite obrazac onlajn prijave.',
        INTRO_MESSAGE_1_LINE_3_1: 'Dobićete potvrdu prijave',
        INTRO_MESSAGE_1_LINE_3_2: ' na ostavljenu imejl adresu odmah po slanju prijave.',
        INTRO_MESSAGE_1_LINE_4_1: 'Na istu imejl adresu stizaće vam',
        INTRO_MESSAGE_1_LINE_4_2: ' sva obaveštenja i odluke o prijavi.',
        INTRO_MESSAGE_2_TITLE: 'PRIPREMITE POTREBNA DOKUMENTA',
        INTRO_MESSAGE_2_TEXT_1: 'U zavisnosti od osiguranog slučaj potrebno je da dostavite sledeća dokumenta.',
        INTRO_MESSAGE_2_TEXT_2: 'Dokumenta označena (*) su obavezna pri podnošenju onlajn prijave.',
        INTRO_MESSAGE_2_SUBTITLE_1: 'U slučaju bolovanja:',
        INTRO_MESSAGE_2_LINE_1_1: 'Doznaka - Izveštaj o privremenoj sprečenosti za rad *',
        INTRO_MESSAGE_2_LINE_1_2: 'Izveštaj lekara po osnovu koga je otvoreno bolovanje *',
        INTRO_MESSAGE_2_SUBTITLE_2: 'U slučaju nezaposlenosti:',
        INTRO_MESSAGE_2_LINE_2_1: 'Rešenje o prekidu radnog odnosa *',
        INTRO_MESSAGE_2_LINE_2_2:
            'Potvrda Nacionalne službe za zapošljavanje (izdata 30 dana nakon prekida radnog odnosa, za svakih 30 dana nezaposlenosti) *',
        INTRO_MESSAGE_2_SUBTITLE_3: 'U slučaju umanjenja zarade iz radnog odnosa:',
        INTRO_MESSAGE_2_LINE_3: 'Rešenje, aneks ili drugi akt o umanjenju zarade *',
        INTRO_MESSAGE_2_SUBTITLE_4: 'U slučaju smrti usled nezgode:',
        INTRO_MESSAGE_2_LINE_4_1: 'Izvod iz matične knjige umrlih *',
        INTRO_MESSAGE_2_LINE_4_2: 'Potvrda o smrti *',
        INTRO_MESSAGE_2_LINE_4_3: 'Izveštaj MUP-a o nastaloj nezgodi *',
        INTRO_MESSAGE_2_LINE_4_4: 'Otpusna lista iz bolnice (ukoliko je smrt nastupila u bolnici)',
        INTRO_MESSAGE_2_LINE_4_5: 'Obdukcioni nalaz sa toksikološkom analizom (ukoliko je izvršena obdukcija)',
        INTRO_MESSAGE_2_SUBTITLE_5: 'U slučaju invaliditeta usled nezgode:',
        INTRO_MESSAGE_2_LINE_5_1:
            'Celokupna medicinska dokumentacija od dana nastanka povrede, u toku lečenja i po završenom lečenju',
        INTRO_MESSAGE_2_LINE_5_2: 'Izveštaj MUP-a o nastaloj nezgodi (ukoliko je sačinjen)',
        INTRO_MESSAGE_2_SUBTITLE_6: 'Napomena:',
        INTRO_MESSAGE_2_LINE_6_1: 'Ukoliko se utvrdi osnovanost zahteva, potrebno je dostaviti i',
        INTRO_MESSAGE_2_LINE_6_2: ' karticu tekućeg računa osiguranika ili zakonskog zastupnika.',
        INTRO_MESSAGE_2_LINE_6_3:
            'Osiguravač može da traži dodatnu dokumentaciju, ako je ta dokumentacija neophodna za isplatu naknade. Troškove pribavljanja dokumentacije za isplatu naknade snosi korisnik osiguranja.',
    },
};

export const policiesProperties = {
    policyNumber: 'brojPolise',
    validFrom: 'vaziOd',
    validTo: 'vaziDo',
    message: 'poruka',
    numberOfWaitingPeriodDays: 'brojDanaKarence',
    numberOfWaitingDays: 'brojDanaPeriodCekanja',
};

export enum legalPersonType {
    initialValue = '0',
    individual = '1',
    legal = '2',
}

export enum personType {
    initialValue = 0,
    submitter = 1,
}

export class constValues {
    static readonly countrySerbiaId: number | string = '197';
    static readonly dialCodeSerbia: string = '+381';
}

export const question15MaxLength = 15;
export const questionMaxLength = 100;
export const question50MaxLength = 50;
export const nameMaxLength = 20;
export const surnameMaxLength = 30;
export const ucnMaxLength = 13;
